#import "../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query SupplierCommonData {
  availableSupplierDocumentPools(orderBy: NAME_ASC) {
    nodes {
      id
      name
      description
    }
  }
  supplierAvailableDocumentTypes(orderBy: DOCUMENT_TYPE_ASC) {
    nodes {
      id
      documentType
    }
  }
  paymentTermTypes(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      paymentTermType
    }
  }
  environmentalMetrics(orderBy: ENVIRONMENTAL_METRIC_ASC) {
    nodes {
      id
      environmentalMetric
    }
  }
  countries(orderBy: COUNTRY_ASC) {
    nodes {
      id
      country
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  vendorServiceTypes {
    nodes {
      id
      vendorType
      isServiceRateAllowed
      isRateRequired
    }
  }
}
